export default "__VITE_ASSET__Cy3qHXn3__"